module.exports = {
  app: {
    refreshSuccess: "刷新成功",
    logoutMSG:
      "您是否確認要登出您的單一登入認證？這將會登出所有使用單一登入認證的系統。",
    appName: "UTM宿舍管理系統",
    login: "登錄",
    fronDeskLogin: "前台系統登錄",
    en: "英文",
    zhTW: "中文繁體",
    backgroundSystemLogin: "後台系統登錄",
    applicationNumber: "申請編號",
    certificateNumber: "證件號碼",
    logout: "退出",
    personalInfo: "個人資料",
    statement: "聲明",
    gender: "性別",
    male: "男",
    female: "女",
    surname: "姓",
    firstName: "名",
    chineseName: "中文名字",
    countryDialCode: "國家撥打代碼",
    mobilePhoneNumber: "手機號碼",
    emailAddress: "電郵",
    applicationForAccommodation: "住宿申請",
    noSpecialPreference: "沒有特別喜好",
    studentsFromTheirCountryOrRegion: "所屬國家或地區的學生",
    internationalStudentsFromOtherRegions: "其他地區的國際學生",
    exchangeStudentsFromOtherInstitutions: "其他院校的交換生",
    arriveInMacau: "抵澳",
    //arriveInMacauCheckInDesc: "本學期宿舍最早可入住日期為8月15日，恕不能早於所填寫的抵達日期前入住。",
    arriveInMacauCheckInDesc: "宿舍自註冊首日（以教務部公告為準）起開放入住，此前恕無法安排入住。",
    arriveInMacauCheckInDesc2: "總宿費按所填寫的抵達日期開始計算。第一學期基本宿費由8月16日至12月31日止，如須提早入住，將按半個月或按行政管理委員會所批准適用於外賓的日收費收取費用(以較低者為準)。",
    dateOfArrivalInMacao: "抵澳日期",
    timeOfArrivalInMacao: "抵澳時間",
    arrivalDateBegin: "抵澳日期起",
    arrivalDateEnd: "抵澳日期止",
    arrivalTimeBegin: "抵澳時間起",
    arrivalTimeEnd: "抵澳時間止",
    portOfArrival: "抵步口岸",
    selectArrival: "請選擇抵步口岸",
    submit: "提交",
    reset: "重置",
    name: "英文名/中文名",
    studentNumber: "學生編號",
    studentAndApplication: "學生編號/申請編號",
    contactNumber: "聯絡電話",
    roomNumber: "房號",
    declarationItems: "申報事項",
    sleepOutDestination: "外宿目的地",
    DateofReturnLateOrSleepOut: "遲歸或外宿日期",
    SubmitDate: "提交日期",
    ExceptionStatus: "異常情況",
    currentRoomNumber: "現住房號",
    yes: "是",
    no: "否",
    changeRoommates: "調換室友",
    changeRoomType: "調換房型",
    changeRoomNumber: "調換房號",
    otherNeeds: "其他需求",
    checkOutDate: "退宿日期 (如同學需額外住宿，學院將根據所填寫退宿日期發出賬)",
    checkInDate: "入住日期",
    planCheckOutDate:
      "退宿日期（如同學需額外住宿，學院將根據所填寫退宿日期發出賬）",
    guestRoom: "客房",
    suite: "套房",
    exchangeStudentsFromTheirInstitutions: "所屬院校的交換生",
    systemManagement: "系統管理",
    roleManagement: "角色管理",
    roomManagement: "房間管理",
    roleCoding: "角色編碼",
    roleName: "角色名稱",
    operation: "操作",
    enable: "是否啟用",
    bindingPermissions: "菜單權限",
    operationPermission: "操作權限",
    edit: "編輯",
    new: "新增",
    userManagement: "用戶管理",
    confirmModification: "確認修改",
    refuseModification: "確認退回申請",
    recoverModification: "確認恢復申請",
    tips: "提示",
    confirm: "確定",
    cancel: "取消",
    confirmAdd: "確認添加",
    delete: "刪除",
    bindRole: "綁定角色",
    username: "發件人",
    userAddress: "發件人郵箱",
    isDelete: "確認刪除嗎？",
    pleaseEnterKeywordSearch: "請輸入關鍵字搜索",
    dictionaryManagement: "字典管理",
    bedTagsManagement: "床位標籤管理",
    opeSuccess: "操作成功",
    success: "成功",
    info: "系統提示",
    account: "學院帳號",
    studentLogin: "登入名稱",
    dicCode: "字典項編碼",
    dicName: "字典項名稱",
    description: "描述",
    isUse: "啟用",
    disable: "禁用",
    serialNumber: "序號",
    dicItem: "字典項",
    dicItemManagement: "字典項管理",
    dicItemCode: "字典項編碼",
    dicItemName: "字典項名稱",
    templateManagement: "模板管理",
    templateCode: "模板編碼",
    templateName: "模板名稱",
    addressee: "收件人",
    CC: "抄送",
    bcc: "密送",
    theme: "主題",
    content: "內容",
    floorName: "樓層名稱",
    floorCode: "樓層編碼",
    roomCode: "房間編號",
    roomType: "房間類型",
    roomStatus: "房間狀態",
    roomRemark: "備註",
    macroInsert: "宏插入",
    dormitoryList: "宿舍列表",
    dormitoryManagement: "宿舍管理",
    mandatoryCheckOutDate: "強制退宿日期",
    room: "房間",
    bed: "床位",
    nameEnglish: "英文名",
    nameChina: "中文名",
    contactInformation: "聯繫方式",
    adjustment: "調整",
    checkOut: "退宿",
    adjustmentApplication: "調整申請",
    remarks: "備註",
    applicationRequirements: "申請需求",
    mandatoryCheckOutDateSetting: "強制退宿日期設置",
    resourceManagement: "資源管理",
    menuName: "菜單名稱",
    menuCode: "菜單編碼",
    parentMenuName: "父級菜單名稱",
    preDistributionOfNewStudents: "新生預分配",
    preDistributionOfOldStudents: "舊生預分配",
    search: "查詢",
    batchConfirmation: "批量確認",
    batchCheckIn: "批量CheckIn",
    batchCheckOut: "批量CheckOut",
    batchSetBedTags: "批量設置床位標籤",
    bedTages: "標籤",
    status: "交費狀態",
    feePaid: "已交費",
    unpaidFee: "未交費",
    confirmS: "確認",
    refuse: "退回",
    recover: "恢復",
    parameterConfiguration: "參數配置",
    accommodationParameterConfiguration: "住宿參數配置",
    mailParameterConfiguration: "郵件參數配置",
    firstSemesterBeginDate: "第一學期開學日期",
    secondSemesterBeginDate: "第二學期開學日期",
    oldStuStartDate: "舊生住宿申請開始日期",
    newStuStartDate: "新生住宿申請開始日期",
    oldStuEndDate: "舊生住宿申請結束日期",
    newStuEndDate: "新生住宿申請結束日期",
    checkOutDateOfTheFirstSemester: "第一學期退宿日期",
    checkOutDateOfTheSecondSemester: "第二學期退宿日期",
    isSubmit: "確認提交嗎？",
    emailHost: "發件伺服器地址",
    emailHostPort: "發件伺服器端口",
    noStuFound: "未查找到學生",
    startPreAlloc: "開始預分配",
    bedCode: "床位編碼",
    bedStatus: "床位狀態",
    viewDetails: "查看",
    details: "詳情",
    dormitoryDiagram: "宿舍示意圖",
    selectAll: "全選",
    password: "驗證密鑰",
    pickUpServiceDate: "接載服務日期",
    exchange: "互換",
    floor: "樓層",
    overnight: "遲歸或外宿",
    financialManagement: "財務管理",
    hotelExpense: "住宿費",
    returnInNight: "紀錄",
    hostelCheckoutReservation: "宿舍退宿預約",
    studentIDNo: "學生證編號",
    contactNo: "聯絡電話",
    residentialInformation: "住宿資料",
    hostelRoomNo: "房號",
    expectedCheckoutDate: "擬退宿日期",
    reasonForLateCheckout: "延遲退宿之原因",
    uploadSupportingDocument: "上載證明",
    expectedCheckoutTime: "擬退宿時間",
    checkInResult: "住宿申請結果",
    Announcement: "住宿申請結果公佈",
    pickUpServiceTime: "接載服務時間",
    checkOutTime: "預約退宿時間",
    checkOutApproval: "退宿審批",
    reportCenter: "報表中心",
    checkIn: "入住查詢",
    pickup: "接載服務時間表",
    checkInStartTime: "入住開始時間",
    checkInEndTime: "入住結束時間",
    checkOutStartTime: "擬退宿開始時間",
    checkOutEndTime: "擬退宿結束時間",
    isCheckIn: "是否入住",
    isNotCheckout: "過期未退宿",
    debit: "開單",
    batchDebit: "批量開單",
    debitConfirmDialog: "是否確認開單",
    debitTitle: "單據詳情",
    internalRemark: "內部備註",
    externalRemark: "外部備註",
    startDate: "開始繳費日期",
    endDate: "繳費期限",
    hostelDeadlineDate: "繳費DEADLINE日期",
    otherName: "別名",
    paymentDateStart: "查詢付款日期起",
    paymentDateEnd: "查詢付款日期止",
    arrivalDateFilterStart: "查詢入住日期起",
    arrivalDateFilterEnd: "查詢入住日期止",
    departureDateFilterStart: "查詢退宿日期起",
    departureDateFilterEnd: "查詢退宿日期止",
    confirmDebit: "確認補單嗎?",
    changeDateBegin: "查詢調整日期起",
    changeDateEnd: "查詢調整日期止",
    currentRoom: "現住宿舍",
    checkoutDate: "預約/強制退宿時間",
    realCheckOutTime: "實際退宿日期",
    startSearchDate: "開始日期",
    endSearchDate: "結束日期",
    studentNative: "籍貫",
    localOrNot: "本地/非本地",
    studentProgramme: "學系",
    specialRequirement: "特別要求",
    to: "至",
    invertSelect: "反選",
    studentType: "學生類型",
    ascOrder: "正序",
    descOrder: "反序",
    hasConfirm: "已確認",
    hasCheckout: "已退宿",
    isApplyHostel: "是否申請住宿",
    applyDate: "最近申請時間",
    isStayover: "是否續住",
    isKeepRoom: "是否保持房間",
    checkOutSearchStartTime: "開始時間",
    checkOutSearchEndTime: "結束時間",
    applicationDescription: "現時不在宿舍申請期內，以下為閣下之申請紀錄。",
    tooltip: "建議使用電腦瀏覽器效果最佳",
    applyTime: "申請時間",
    applyStatus: "申請狀態",
    haveRead: "已閱",
    noRead: "未閱",
    defaultFee: "費用",
    roomIndexNotEAHstartWith: "房間編號不符合規則，例如沒有以EAH-作前綴標識",
    validation: {
      complete: "請將信息補充完整",
      declare: "请先閱讀聲明",
      applyCode: "请输入申請編號",
      gender: "请選擇性別",
      surname: "请输入您的姓氏",
      name: "请输入您的名字",
      countryCode: "请输入國家撥打代碼",
      tel: "请输入您的手機號碼",
      email: "请输入您的電郵",
      category: "请選擇房型",
      roommate: "请選擇室友",
      serve: "请選擇服務",
      direction: "请選擇抵步口岸",
      date: "請選擇日期",
      time: "請選擇時間",
      studentNumber: "請輸入學生編號",
      reason: "請輸入原因",
      roomNumber: "請輸入房號",
      phone: "請輸入聯絡電話",
      select: "請選擇",
      destination: "請輸入目的地",
      currentRoomNumber: "請輸入現住房號",
      isKeepFalse: "不申請住宿不可選",
      room: "請輸入房號",
      reasonOfCheckOut: "請填寫延遲退宿之原因"
    },
    router: {
      home: "首頁",
      homeB: "首頁",
      newStu: "首頁",
      oldStu: "首頁",
      applicationForAccommodation: "住宿申請",
      applicationForAccommodationOld: "住宿申請",
      nightReturnRegistration: "遲歸或外宿申報表",
      nightReturnParent: "遲歸或外宿",
      systemManagement: "系統管理",
      roleManagement: "角色管理",
      userManagement: "用戶管理",
      dictionaryManagement: "字典管理",
      templateManagement: "模板管理",
      roomManagement: "房間管理",
      dormitoryList: "宿舍列表",
      dormitoryManagement: "宿舍管理",
      resourceManagement: "資源管理",
      preDistributionOfNewStudents: "新生預分配",
      preDistributionOfOldStudents: "舊生預分配",
      parameterConfiguration: "參數配置",
      dormitoryDiagram: "宿舍示意圖",
      overnight: "遲歸或外宿",
      financialManagement: "財務管理",
      hotelExpense: "住宿費",
      returnInNight: "遲歸或外宿紀錄",
      hostelCheckoutReservation: "宿舍退宿預約",
      checkInResult: "住宿申請結果",
      checkOutApproval: "退宿審批",
      reportCenter: "報表中心",
      checkIn: "Room List Report",
      guest: "訪客住宿",
      guestAppointment: "入住預約",
      guestAppointmentList: "預約列表",
      pickup: "Pick Up Time Table",
      checkOut: "Checkout Report",
      arrival: "Arrival Report",
      bedChange: "Bedspace Change Report",
      bed: "Room/Bed Status Report",
      departure: "Departure Report",
      payment: "Payment Report",
      guestReport: "Outside Guest Report",
      documentManagement: "資料管理",
      documentStudent: "學生資料",
      cashierReport: "Cashier Report",
      cashier: "Cashier Report",
      hostelApplyList: "住宿申請情況",
      hostelCheckoutHistory: "學生退宿記錄",
      logViewer: "操作日誌",
      studentApplicationHistory: "學生申請記錄",
      BedTagsManagement: "床位標籤管理",
      bedtagBalance: "BedtagBalance Report"
    },
    loginView: {
      newStudent: "新生入口",
      oldStudent: "在讀生入口"
    },
    applyView: {
      leaveDate: "離港日期",
      leaveTime: "離港時間",
      flightNumber: "航班號",
      departurePort: "離港口岸(機場名稱和城市或國家)",
      statementMSG: "本人已詳細閱讀所有有關學生宿舍資料",
      name: "名",
      originalInstitution: "原屬院校及其所在地(此項只適用於交換生)",
      roomChoose: "房型選擇(宿舍費用每學期繳交一次，每學期收費按校曆表而定):",
      single: "單人房 (需視乎供應)",
      //每人每月澳門幣2,400;數量有限，若申請人數超出房間數量時，將以抽籤形式安排
      double: "雙人房",
      //(每人每月澳門幣1,200)
      roommate: "室友選擇 (僅適用於同性別的學生):",
      other: "如需特別安排，請註明：",
      OtherRequirement: "備註",
      declareCost:
        "本人已知悉宿舍房內的電費並不包括在宿舍費內，宿生按每月實際使用量，由同房宿生分擔及支付有關費用。",
      serve: "口岸抵步接載服務",
      serveI: "抵澳後本人將自行前往澳門旅遊學院東亞樓",
      serveII: "本人欲於抵澳時獲得接載服務。",
      pathI: "乘坐飛機抵達澳門國際機場",
      pathII: "經陸路抵達澳門關閘邊檢大樓(須通過拱北口岸及澳門關閘邊檢關口)",
      pathIII: "經海路抵達澳門外港客運碼頭",
      pathIV: "經海路抵達澳門氹仔臨時客運碼頭",
      pathV: "經海路抵達澳門內港客運碼頭",
      pathVI: "經陸路抵達路氹邊檢站",
      declareFinal:
        "茲特此聲明上述宿舍房間之租賃申請為本人最終決定，且同意於入住期間遵守有關宿舍規章。由於各房間類別供應有限，學院將按申請次序分配宿位，因此，並不能保證能入住所要求類別。"
    },
    checkoutView: {
      statement:
        "本人已知悉退宿後禁止存放個人物品於宿舍房間內，任何遺留於宿舍房間內之個人物品宿舍管理小組有權作處置。",
      remarksA:
        "1.宿生需於擬退宿日期最少三天前或最遲於12月28日（第一學期）或5月28日(第二學期）提交綢上宿舍退宿申請表。",
      remarksB:
        "2.宿生有責任清理房間內的個人物品並徹底打掃房間；房內的傢俬必須放回原位。",
      remarksC:
        "3.退宿時，舍監會檢查房間並安排存放行李，過程大概需時 15 至20 分鐘，宿生請預留時間並預先執拾好房間內之個人物品。",
      remarksD:
        "4.已申請續住宿舍之宿生可暫存最多三件行李，逾期未領取之行李將作廢物棄掉。行李或行李內物品如有遺失或損壞，學院概不負責。"
    },
    overnightView: {
      factor: "請選擇一個符合的選項：",
      factorI: "由於家位於澳門附近，每逢星期五至日及假期都會回家",
      factorII: "其他原因之外宿",
      factorIII: "遲歸",
      date: "遲歸或外宿日期：",
      reason: "遲歸或外宿的原因：",
      declare: "本人聲明在此申報表內所填寫的各項資料均屬正確、完備和真實。",
      isLeave: "目的地(請註明地區)"
    },
    applyOldView: {
      isContinue: "請問下學期是否需要申請續住宿舍。",
      noI: "否，我將到海外實習/交流。",
      noII:
        "否，我將自行安排住宿（退宿後，宿位將不予以保留，如欲重新申請，將按實際宿位數量而決定）。",
      noIII: "否，我已完成所有課程準備畢業。",
      isKeep: "是否保持上一學期房間分配(所有選項均不能保證)",
      specialTypeDetail: "獎學金"
    },
    // 新增房型選擇 laotang 2023-04-12
    roomTypeSelect: {
      title:
        "房型選擇(因個別房型數量有限，若同學所選的房型超出可安排之數量時，本校將以隨機抽籤方式決定)",
      noI: "單人房（1-17樓）",
      noII: "雙人房（1-17樓）",
      noIII: "園景雙人房（18-21樓翻新樓層）",
      noIIII: "海景雙人房（18-21樓翻新樓層）",
      noIIIII: "三人房（1-17樓）",
      noIIIIII: "四人房（1-17樓）",
      remark1:
        "註：由於宿位有限，每年將優先考慮首年入讀的本科生，因此不保證翌年必定能夠續住。研究生的住宿申請暫無法保證並列入候補名單，結果將在8月初透過電子郵件公佈。房間按學生申請次序先後安排，如所選擇的房型已滿，則安排入住其他可供房型。宿舍收費請參閱宿舍網頁。"
    },
    template: {
      name_address_un: "與名字、地址無關的項",
      sender: "與發件人相關的項",
      recipients: "與發件人相關的項",
      topic: "與主題相關的項",
      cursor: "編輯器光標位置",
      quotes: "引用原郵件內容",
      text: "原郵件內容",
      date: "當前日期",
      time: "當前時間",
      oDate: "來信日期",
      oTime: "來信時間",
      oSubject: "來信主題",
      attachList: "附件列表",
      onoContent: "不使用或引用元郵件內容",
      fromName: "發件人名字",
      replyName: "回復名字",
      fromAddr: "發件人郵箱地址",
      replyAddr: "回復地址",
      oFromName: "原郵件的發件人名字",
      oReplyName: "原郵件的回復名字",
      oFromAddr: "原郵件的發件人郵箱地址",
      oReplyAddr: "原郵件的回復地址",
      toName: "收件人名字",
      toAddr: "收件人郵件地址",
      oToName: "原郵件的收件人名字",
      oToAddr: "原郵件的收件人地址",
      OccName: "原郵件的抄送人名字",
      OccAddr: "原郵件的抄送人地址",
      sDate: "系統當前日期",
      sTime: "系統當前時間"
    },
    schoolYear: "學年",
    semester: "學期",
    bedTags: {
      code: "床位標籤編碼",
      name: "床位標籤名稱",
      enable: "是否啟用",
      schoolYear: "學年",
      description: "備注說明",
      confirmModification: "是否確認複製選中的學年標籤數據？"
    }
  }
};
